/**
 * @generated SignedSource<<099685cff28db5e81ac92733301ced3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskNameChip_task$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TaskNameChip_task";
};
export type TaskNameChip_task$key = {
  readonly " $data"?: TaskNameChip_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskNameChip_task">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskNameChip_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node as any).hash = "a5ec9f36102ce19b982ba0cb0350136f";

export default node;
